import { render, staticRenderFns } from "./LsportDetailCorrectScorePrice.vue?vue&type=template&id=81e6f064&scoped=true"
import script from "./LsportDetailCorrectScorePrice.vue?vue&type=script&lang=js"
export * from "./LsportDetailCorrectScorePrice.vue?vue&type=script&lang=js"
import style0 from "./LsportDetailCorrectScorePrice.vue?vue&type=style&index=0&id=81e6f064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e6f064",
  null
  
)

export default component.exports